import { useMutation } from "@apollo/client";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { CreateOutboundDeliveryMutation } from "../../../graphql/deliveryService/mutations/createOutboundDelivery";
import { handleError } from "../../../utils/graphqlHelper";

interface CreateOutboundDeliveryMutationProps {
  dataAction: (id: string) => void;
  errorAction?: () => void;
}

const useCreateOutboundDeliveryMutation = (
  props: CreateOutboundDeliveryMutationProps,
) => {
  const { t } = useTranslation();
  const { dataAction, errorAction } = props;

  const mutation = useMutation(CreateOutboundDeliveryMutation, {
    update: (cache) => {
      cache.evict({ fieldName: "outboundDeliveries" });
      cache.gc();
    },
  });

  const { data, error } = mutation[1];

  const outboundDeliveryCreated =
    data?.createOutboundDelivery.outboundDeliveryDetail;

  useEffect(() => {
    if (!error) return;

    handleError(t("createOutboundDeliveryError"), error.message, errorAction);
  }, [error]);

  useEffect(() => {
    if (!data) return;

    if (outboundDeliveryCreated) dataAction(outboundDeliveryCreated.id);
  }, [data]);

  return mutation;
};

export default useCreateOutboundDeliveryMutation;
